/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';
import type { PartnerProjection } from './PartnerProjection';
import {
    PartnerProjectionFromJSON,
    PartnerProjectionFromJSONTyped,
    PartnerProjectionToJSON,
    PartnerProjectionToJSONTyped,
} from './PartnerProjection';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string | null;
    /**
     * 
     * @type {Company}
     * @memberof User
     */
    companyId?: Company | null;
    /**
     * 
     * @type {PartnerProjection}
     * @memberof User
     */
    partnerId?: PartnerProjection | null;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'companyId': json['company_id'] == null ? undefined : CompanyFromJSON(json['company_id']),
        'partnerId': json['partner_id'] == null ? undefined : PartnerProjectionFromJSON(json['partner_id']),
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'company_id': CompanyToJSON(value['companyId']),
        'partner_id': PartnerProjectionToJSON(value['partnerId']),
    };
}

